const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeight = this.setHeight.bind(this)

    window.addEventListener('resize', this.setHeight)
    this.setHeight()

    this.setVisibleHeight()

    this.setupMarquee = this.setupMarquee.bind(this)
    this.setupMarquee()
    window.addEventListener('resize', this.setupMarquee)

    if (this.els.slide.elements.length < 2) return

    this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.setVisibleHeight = this.setVisibleHeight.bind(this)

    this.listeners.add(window, 'scroll', this.setVisibleHeight)
  }

  setVisibleHeight () {
    this.visibleHeight =
      this.els.body.element.offsetHeight - window.scrollY > 0
        ? this.els.body.element.offsetHeight - window.scrollY
        : 0

    document.documentElement.style.setProperty(
      '--Announcement_VisibleHeight',
      `${this.visibleHeight}px`,
    )
  }

  setHeight () {
    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )
  }

  setupMarquee () {
    const bodyWidth = this.els.body.element.offsetWidth
    this.els.text.elements.forEach(el => {
      el.style.setProperty('--Width', `${el.offsetWidth}px`)

      el.classList.toggle(
        'hd-Announcement_Text-marquee',
        el.offsetWidth > bodyWidth,
      )
    })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
